import { SentinelComment } from './SentinelComment.js';

export function SentinelVisit(logbookNote) {
    'use strict';

    var self = this;
    this.noteLink = logbookNote._links.self.href;
    this.logId = logbookNote.logId;
    this.noteId = logbookNote.id;
    this.created = logbookNote.created;
    this.updated = logbookNote.updated;
    this.comments = [];
    this.firstName = null;
    this.lastName = null;
    this.formattedName = null;
    this.company = null;
    this.visiting = null;
    this.reason = null;
    this.profilePicture = null;
    this.facilityName = null;
    this.badgeCodeManual = null;
    this.checkInTime = null;
    this.checkOutTime = null;
    this.doorIn = null;
    this.doorOut = null;
    this.escortIn = null;
    this.escortOut = null;
    this.id = null;
    this.deviceId = null;
    this.timeRegistered = logbookNote.created;
    this.telephone = null;
    this.isCitizen = null;
    this.nda = null;
    this.lastEdit = null;
    this.removed = null;

    function mapTemplateSegments(segment) {
        switch(segment) {
            case "First Name":
                return "firstName";
                break;
            case "Last Name":
                return "lastName";
                break;
            case "Company":
                return "company";
                break;
            case "Visiting":
                return "visiting";
                break;
            case "Reason":
                return "reason";
                break;
            case "Profile Picture":
                return "profilePicture";
                break;
            case "Facility":
                return "facilityName";
                break;
            case "Telephone":
                return "telephone";
                break;
            case "Are you a U.S. Citizen?":
                return "isCitizen";
                break;
            case "Have you signed an NDA with the company?":
                return "nda";
                break;
            case "Manual Badge Code":
                return "badgeCodeManual";
                break;
            case "Check-in Time":
                return "checkInTime";
                break;
            case "Check-out Time":
                return "checkOutTime";
                break;
            case "Door In":
                return "doorIn";
                break;
            case "Door Out":
                return "doorOut";
                break;
            case "Escort In":
                return "escortIn";
                break;
            case "Escort Out":
                return "escortOut";
                break;
            case "ID":
                return "id";
                break;
            case "Device ID":
                return "deviceId";
                break;
            case "Registration Time":
                return "timeRegistered";
                break;
            case "Last Edit":
                return "lastEdit";
                break;
            case "Removed":
                return "removed";
                break;
        }
    }

    logbookNote.templateValues.forEach(function (value) {
        var templateSegmentName = mapTemplateSegments(value.templateSegmentName);
        if (templateSegmentName === "profilePicture") {
            self[templateSegmentName] = value.fileAttachments[0].id;
        } else {
            self[templateSegmentName] = (templateSegmentName === 'checkInTime' || templateSegmentName === 'checkOutTime' || templateSegmentName === 'timeRegistered' || templateSegmentName === 'lastEdit')
                ? moment(value.value).toDate()
                : value.value;
        }
    });

    this.formattedName = this.firstName + " " + this.lastName;

    this.comments = logbookNote.noteComments.map(function (lbComment) {
        return new SentinelComment(lbComment);
    });
};